import { useContext } from "react";
import useSWR from "swr";
import { ChasablesContext, ChasableSignalRContext as SignalRContext } from "../context/ChasablesContext";
import { PayableDetailsModel } from "@attelas/shared";

export function usePayable(invoiceId: string | undefined | null) {
  const { isLoading: isConnecting } = useContext(ChasablesContext);

  const { data, isLoading, error, mutate } = useSWR(
    invoiceId && !isConnecting ? ["GetExternalPayable", invoiceId] : null,
    () => SignalRContext.connection?.invoke<PayableDetailsModel>("GetExternalPayable", invoiceId, null)
  );

  return {
    payable: data,
    isLoading,
    isError: !!error,
    refetchPayable: () => mutate(),
  };
}
